import { Alert } from 'components';
import { useTranslation } from 'react-i18next';

export const ErrorCard = () => {
	const { t } = useTranslation(['labels']);

	return (
		<Alert variant='error' className='mt-4'>
			{t('labels:empty')}
		</Alert>
	);
};
